import React from "react";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
} from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    minHeight: '-webkit-fill-available',
  },
}));
const DialogLayout = ({
  open,
  onCloseDialog,
  title,
  contentText,
  children,
  fullScreen,
  color = "#FFFFFF",
  maxWIdth = "lg",
  minHeight,
}) => {
  if (typeof fullScreen === "undefined") {
    fullScreen = false;
  }
  if (typeof minHeight === "undefined") {
    minHeight = false;
  }
  const classes = useStyles();
  return (
    <Dialog
      fullScreen={fullScreen}
      fullWidth={true}
      maxWidth={maxWIdth}
      open={open}
      onClose={onCloseDialog}
      aria-labelledby="form-dialog-title"
      classes={{ paper: minHeight === true ? classes.dialogPaper : null }}
    >
      {title !== "" ? (
        <DialogTitle id="form-dialog-title">
          {title}
          <div
            className="kt-dialog-panel__close"
            onClick={onCloseDialog}
          >
            <i className="flaticon2-delete" />
          </div>
        </DialogTitle>
      ) : null}
      <DialogContent style={{ backgroundColor: color }}>
        {contentText !== "" ? (
          <DialogContentText>{contentText}</DialogContentText>
        ) : null}
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default DialogLayout;
